var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBenefitProzesse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.02 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #defc70;\n      }\n\n      .st1 {\n        fill: #fff;\n        font-family: DINPro-Regular, DINPro;\n        font-size: 14.07px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 11.31,
    y: 2.69,
    width: 7.27,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.76,28.92c-1.51.73-3.13,1.1-4.82,1.1-6.1,0-11.06-4.96-11.06-11.06S8.84,7.9,14.94,7.9c3.77,0,7.27,1.93,9.3,5.08,1.28-.03,1.49-.05,1.49-.05-2.08-3.71-5.92-6.09-10.14-6.31v-1.96h-1.3v1.96c-6.51.34-11.71,5.75-11.71,12.34s5.55,12.36,12.36,12.36c1.89,0,3.7-.42,5.39-1.23l.58-.28-1.15-.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1.44,
    y: 8.51,
    width: 5.61,
    height: 1.3,
    transform: "translate(-5.23 5.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.06,24.52l-1.2-1.05c.05-.33.08-.66.08-.99s-.03-.68-.08-1.03l1.19-1.04.16-.95-1.27-2.19c-.19-.31-.56-.44-.9-.33l-1.51.52c-.53-.43-1.11-.76-1.75-1l-.31-1.55-.74-.61h-2.52l-.74.61-.31,1.57c-.63.24-1.21.58-1.74,1.01l-1.49-.51c-.34-.12-.72.02-.91.34l-1.26,2.18.16.95,1.2,1.05c-.05.33-.08.66-.08.99s.03.69.08,1.03l-1.18,1.03c-.28.23-.36.64-.17.96l1.26,2.18c.18.32.57.46.9.34l1.51-.52c.53.43,1.12.76,1.75,1l.3,1.55.75.61h2.52l.75-.61.31-1.57c.63-.25,1.22-.59,1.74-1.01l1.5.52.89-.33,1.26-2.18-.16-.96ZM30.06,26.62l-1.38-.47-.63.25c-.54.49-1.16.85-1.87,1.08l-.57.45-.28,1.45h-1.63l-.28-1.45-.63-.4c-.69-.22-1.31-.58-1.87-1.07l-.57-.28-1.4.48-.81-1.41,1.1-.96.1-.7c-.08-.36-.12-.73-.12-1.09s.04-.71.11-1.06l-.1-.7-1.11-.97.81-1.41,1.4.48.68-.25c.54-.49,1.16-.85,1.85-1.08l.52-.45.28-1.45h1.63l.28,1.44.44.46c.69.22,1.32.58,1.88,1.08l.76.22,1.4-.48.81,1.41-1.12.98-.09.68c.08.36.12.73.12,1.09s-.04.71-.11,1.08l.12.68,1.11.97-.81,1.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 24.99,
    y: 6.35,
    width: 1.3,
    height: 5.61,
    transform: "translate(1.04 20.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.12,14.36l1.04-.78c-1.69-2.27-4.39-3.62-7.22-3.62-4.97,0-9.01,4.04-9.01,9.01s4.04,9.01,9.01,9.01c.42,0,.85-.03,1.28-.09l.3-.04s-.58-1.23-.64-1.22c-.31.04-.63.06-.94.06-4.25,0-7.71-3.46-7.71-7.71s3.46-7.71,7.71-7.71c2.45,0,4.71,1.13,6.18,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.47,19.16c-1.84,0-3.34,1.5-3.34,3.34s1.5,3.34,3.34,3.34,3.34-1.5,3.34-3.34-1.5-3.34-3.34-3.34ZM24.47,24.55c-1.12,0-2.04-.92-2.04-2.04s.92-2.04,2.04-2.04,2.04.92,2.04,2.04-.92,2.04-2.04,2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14.29 18.32 10.2 18.32 10.2 19.62 14.9 19.62 15.59 18.92 15.59 12.6 14.29 12.6 14.29 18.32"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(29.61 26.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBenefitProzesse);
export default __webpack_public_path__ + "static/media/Icons_Benefit_Prozesse.6d7b6553cd320a1fe229f381c649df31.svg";
export { ForwardRef as ReactComponent };